





































































































import Vue from 'vue'
import { Component } from '@niknevis/vue-modules'
import { Prop } from 'vue-property-decorator'
import BaseButton from '@/modules/shared/components/shared/kit/BaseButton.vue'
import Modal from '@/modules/common/dialog/components/shared/Modal.vue'
import Toggle from '@/modules/shared/components/shared/kit/Toggle.vue'
import Checkbox from '@/modules/shared/components/shared/kit/Checkbox.vue'
import Radio from '@/modules/shared/components/shared/kit/Radio.vue'
import AdminUserSearch from '@/modules/user/components/admin/AdminUserSearch.vue'
import BaseInput from '@/modules/shared/components/shared/kit/BaseInput.vue'
import QPopupProxy from 'quasar/src/components/popup-proxy/QPopupProxy.js';
import { ContentItemStatus } from '@/modules/content-item/models/content-item-resource.model'
import {
  AdminContentItemSendToQueueUseCase
} from '@/modules/content-item/use-cases/admin/admin-content-item-send-to-queue.use-case'
import { ContentItemSendToQueueRequestModel } from '@/modules/content-item/models/content-item-request.model'
import dayjs from 'dayjs'
import { DateHelper } from '@/modules/shared/helpers/date'
import AdminWriterSearch from '@/modules/user/components/admin/AdminWriterSearch.vue'
import AdminContentManagerSearch from '@/modules/user/components/admin/AdminContentManagerSearch.vue'


@Component({
  components: {
    AdminContentManagerSearch,
    AdminWriterSearch,
    BaseButton,
    Modal,
    Toggle,
    Checkbox,
    Radio,
    AdminUserSearch,
    BaseInput
  }
})
export default class AdminContentItemSendToQueue extends Vue {
  constructor(
    private readonly sendToQueueUseCase: AdminContentItemSendToQueueUseCase,
    private readonly dateHelper: DateHelper
  ) {
    super()
  }

  @Prop({ required: true }) contentItemId: number
  @Prop({ default: '' }) productionGuide: string
  @Prop({ default: 'ارسال برای نگارش' }) label: string
  @Prop({ default: '' }) status: ContentItemStatus
  @Prop({}) editorId: number
  private dialogModel: boolean = false
  private requestData: ContentItemSendToQueueRequestModel = this.initialData()

  $refs!: {
    refPopupDeliverAt: QPopupProxy,
  }

  get deliverAt() {
    return (this.requestData.deliver_at) ? this.gregoryToJalali(this.requestData.deliver_at) : ''
  }

  set deliverAt(value) {
    this.requestData.deliver_at = this.jalaliToGregory(value)
  }

  onOpen() {
    this.dialogModel = true
    this.requestData = this.initialData()
    this.requestData.deliver_at = this.jalaliToGregory(dayjs().add(1, 'day').format('YYYY/MM/DD').toString())
  }

  onSubmit() {
    this.sendToQueueUseCase.execute(this.contentItemId, this.requestData).then(() => {
      if (this.sendToQueueUseCase.isSuccess) this.dialogModel = false
    })
  }

  dateOptions(date) {
    return date > this.gregoryToJalali(new Date())
  }

  get showTooltip() {
    return !Boolean(this.label)
  }


  get sendToQueueShow() {
    let statuses = [
      ContentItemStatus.COMPLETED,
      ContentItemStatus.WAITING_PAYMENT,
      ContentItemStatus.CANCELLED
    ]
    return !statuses.includes(this.status)
  }

  jalaliToGregory(value) {
    return value ? this.dateHelper.fromJalali(value).toTimestamp() : null
  }

  gregoryToJalali(value) {
    return value ? dayjs(value).format('YYYY/MM/DD') : null
  }

  initialData(): ContentItemSendToQueueRequestModel {
    return {
      writer: null,
      editor: null,
      status: ContentItemStatus.QUEUE,
      deliver_at: null,
      notify_to_user: true,
      production_guide: this.productionGuide
    }
  }

}
